import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"facebook\">\n  <circle cx=\"24\" cy=\"24\" r=\"24\" />\n  <path transform=\"translate(19 14)\" fill=\"#FFF\" d=\"M6.842 20v-8.666h2.653l.398-3.379h-3.05V5.8c0-.978.246-1.644 1.526-1.644L10 4.154V1.132A20.25 20.25 0 0 0 7.624 1C5.27 1 3.66 2.574 3.66 5.464v2.491H1v3.379h2.66V20h3.182z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 439
// module chunks = 0